import gql from 'graphql-tag'

export default gql`query user($user_id: Int!){
  user(user_id: $user_id){
    undertime_weeks{
      week_commencing
      total_minutes_worked
    }
  }
}`